import { createStyle } from '@gluestack-style/react';

export const Box = createStyle({});
